export default __webpack_public_path__ + "static/media/GE__FREE_CHOICE.7e8e2b4f.png";